import { CarouselItem } from './types';

export const testimonialsDataEN: CarouselItem[] = [
  {
    text: 'Yoga International offers a broad range of instructors who have expertise in a wide variety of yoga styles. I recommend the site to my students on a regular basis. I enjoy the variety of levels, time commitment and subject matter presented as well as the articles and workshops. Definitely worth the membership fee!',
    name: 'Polly',
    role: 'YI Member',
    stars: 5,
    id: '1',
  },
  {
    text: 'I absolutely love Yoga International. It is like a trusted friend. I always find something to practice that suits my needs whether they are physical, emotional or spiritual. It is by far the best online yoga site around.',
    name: 'Edy',
    role: 'YI Member',
    stars: 5,
    id: '2',
  },
  {
    text: 'In only one week my low back pain is almost gone and my sleep is better. ',
    name: 'Pam',
    role: 'YI Member',
    stars: 5,
    id: '3',
  },
  {
    text: "I Love Yoga International - the website is intuitive to use and I've found I now practice every day. Being able to choose a class that fits with my day to day capacity has made all the difference, and there's such breadth of choice.",
    name: 'Kim',
    role: 'YI Member',
    stars: 5,
    id: '4',
  },
  {
    text: "I am a yoga teacher myself, and my experience is that the classes are creative and innovative, I learn something new almost every time. I enjoy practicing and taking classes with so many of these teachers, it's become part of my lifestyle.",
    name: 'Christina',
    role: 'Yoga Teacher',
    stars: 5,
    id: '5',
  },
  {
    text: 'YI gives such a variety of classes so there is always something for every time of the day and week and mood. Ongoing learning programs, interesting and inspiring articles and up to date teachings support.',
    name: 'Choice',
    role: 'Yoga Teacher',
    stars: 5,
    id: '6',
  },
  {
    text: "As a mum of a toddlerI can't find much time going to the gym but I can always fit in a practice of Yoga International. I love the variety of courses, the huge number of professionals and the instant mood boost once I have finished a course. Can highly recommend it!",
    name: 'Mimi',
    role: 'Yoga Teacher',
    stars: 5,
    id: '7',
  },
  {
    text: "I love Yoga International. It is the answer to my ME time. As a Personal Trainer, Group Fitness Instructor, Nutrition Coach and full-time Mom, I rarely get time for myself. With YI, I just switch on, & follow the class recommended and Voila, I'm in sync with my body again.",
    name: 'Natalie',
    role: 'Yoga + Fitness Instructor',
    stars: 5,
    id: '8',
  },
  {
    text: 'Great platform with a wide selection of yoga classes. I usually go for more vigorous classes but was also very pleased to find a lot of options for pregnancy and postpartum yoga.',
    name: 'Sara',
    role: 'YI Member',
    stars: 5,
    id: '9',
  },
  {
    text: 'I enjoy different types of classes and just discovered the benefits of kundalini yoga. I can easily choose duration and preferable teacher. I really feel like I have the whole yoga world always with me and available when I wish.',
    name: 'Sami',
    role: 'YI Member',
    stars: 5,
    id: '10',
  },
  {
    text: "Wow, I didn't realize how much I needed a Yin Yoga class with Corina. My emotional, spiritual and physical state were better after Savasana. Thank you for the opportunity.",
    name: 'Paulina',
    role: 'YI Member',
    stars: 5,
    id: '11',
  },
  {
    text: 'Yoga International is a lovely space to grow and deepen your practice. Helpful filters, class suggestions and ability to track your progress and goals. I highly recommend!',
    name: 'Chandra',
    role: 'YI Member',
    stars: 5,
    id: '12',
  },
  {
    text: "I don't have a lot of time to practice and join live yoga classes, but due to the skills of teachers at Yoga International, it feels like a great live class! I have been a member for ages (a yoga teacher as well) and participated in many great courses - I highly recommend it!",
    name: 'M.',
    role: 'Yoga Teacher',
    stars: 5,
    id: '13',
  },
  {
    text: 'No matter how I am feeling, there is always a class or meditation for me. The filters are so helpful to find the best options for your time frame and preferred focus.I have taken 4 courses and am currently enrolled in another one, they are all worth the investment.',
    name: 'Melissa',
    role: 'YI Member',
    stars: 5,
    id: '14',
  },
  {
    text: 'I really feel like I have the whole yoga world always with me and available when I wish!',
    name: 'Aleksandra',
    role: 'YI Member',
    stars: 5,
    id: '15',
  },
];
